import { ProductCategoryEnum, TransactionType } from "@gtpl/shared-models/common-models"

export class PackingInfoReq{
    lotNumber : string
    saleOrderItemId : number 
    cartons: number
    loosePouches : number
    plantId : number
    createdUser : string
    transactionType : TransactionType
    year:number
    stockInDate:any
    rejectionFrom?:string
    gradeChange?:boolean
    soakingOutproduct?:string
    productCategory?:ProductCategoryEnum
    reportingLogId?: number
    quantity ?: number


    constructor( lotNumber : string,saleOrderItemId : number,cartons:number,loosePouches:number,plantId : number,createdUser : string,transactionType : TransactionType,year:number,stockInDate:any,rejectionFrom?:string,gradeChange?:boolean,soakingOutproduct?:string,productCategory?:ProductCategoryEnum,reportingLogId?: number,quantity ?: number){
        this.lotNumber = lotNumber
        this.saleOrderItemId = saleOrderItemId
        this.cartons = cartons
        this.loosePouches = loosePouches
        this.plantId = plantId
        this.createdUser = createdUser
        this.transactionType = transactionType
        this.year = year
        this.stockInDate = stockInDate
        this.rejectionFrom = rejectionFrom
        this.gradeChange = gradeChange
        this.soakingOutproduct = soakingOutproduct
        this.productCategory = productCategory
        this.reportingLogId = reportingLogId
        this.quantity = quantity
    }
}